import { ButtonHTMLAttributes } from 'react';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  confirmMessage?: string;
};

export function Button({ variant = 'primary', className = '', confirmMessage, onClick, ...props }: ButtonProps) {
  return <button className={`button button--${variant} ${className}`.trim()} {...props} onClick={(event) => { if (!confirmMessage || window.confirm(confirmMessage)) onClick?.(event); }} />;
}
